/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-14 09:50:35
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { line } from "d3";
import { toVisualThousands } from "../utils";
import { xAxisLabelColor, yAxisLabelColor } from "../visualConfig";

export default  ({ list = [], color = [] }) => {
  const _data = [...list];
  const _color = [...color];
  // _data.reverse();
  _color.reverse();
  return {
    title: {
      text: '数字品牌价值（单位：{db|DB}）',
      align: 'left',
      top: 30,
      textStyle: {
        color: '#000',
        rich: {
          db: {
            fontStyle: 'italic'
          }
        },
      }
   },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    color: _color,
    legend: {
      top: 20,
      right: 5,
      orient: 'vertical',
      inverse: true,
      icon: 'stake',
      itemWidth: 14,
      itemHeight: 14,
      data: _data.map(item => item.name),
      textStyle:{
        fontSize: 16,
        color: '#000',
        lineHeight: 30,
        fontWeight: 'bold'

      }
    },
    grid: {
      top: 100,
      right: 0,
      bottom: '5%',
      containLabel: false
    },
    xAxis: {
      type: 'category',
      show: false,
      axisLabel: { ...xAxisLabelColor },
      axisLine: { show: false },
      axisTick: { show: false },
      minorTick: { show: false },
      splitLine: { show: false },
    },
    yAxis: {
      axisLabel: { ...yAxisLabelColor,fontSize: 16, fontWeight: 'bold' },
      splitLine: { show: false },
    },
    series: _data.reverse().map((item, index) => {
      var maxValue = Math.max.apply(null, item.list.map(function(item) { return item.value; }));
      return{
        stack: 'same',
        type: 'bar',
        barWidth: '20%',
        name: item.name,
        data: item.list,
        label: {
          // normal: {
            show: true,
            position:  index === 1 && 'top',
            formatter: function(params) {
              if(index === 1 &&params.value == maxValue) {
                return `{a|■ ${params.value}}`
              } else if(index === 1 && params.value !== maxValue){
                return `{a|■} {b|${params.value}}`

              }else {
                return `{c|■} {b|${toVisualThousands(params.value)}}`
              }
              
            },
            rich: {
              a: {
                color: color[0],
                // backgroundColor: {
                //   image: function(params) { // 使用函数动态设置背景颜色为图例颜色
                //         return `data:image/svg+xml,<svg height="15" width="15" style="background-color:${color}"></svg>`;
                //     }
                // },
                align: 'center',
                display: 'inline-block',
              },
              b: {
                color: '#000',
              },
              c: {
                color: color[1],
                align: 'center',
                display: 'inline-block',
              },
            }
          // }
        }
    }}),
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P40/chart.js